<template>
  <div>
    <div class="d-flex flex-row justify-content-between">
      <span class="h4">Selected Users</span>

      <div>
        <div class="btn-group mb-4" role="group" v-for="(button, index) in buttons" :key="index">
          <button class="btn btn-secondary" id="btn-inactive" :press.sync="button.status"
            :class="{ 'change-background': button.status }" @click="handleButtonClick(index, 'selectedIndex', 'buttons')" type="button">
            {{ button.name }}
          </button>
        </div>
      </div>
    </div>

    <div>
      <generalData :table_id="'general-table'" :arrayData="mainData.all_users" v-if="selectedIndex == 0"/>
      <generalData :table_id="'existing-table'" :tableHeader="['account_number', 'name', 'ic_number', 'mobile_number']" :arrayData="mainData.existing_users" v-if="selectedIndex == 1"/>
      <nonExisting :table_id="'non-existing-table'" :arrayData="mainData.non_existing_users" v-if="selectedIndex == 2"  @update:arrayData="updateNonExistingUsers" />
      <generalData :table_id="'newly-register-table'" :tableHeader="['account_number', 'name', 'ic_number', 'mobile_number']" :arrayData="mainData.newly_registers" v-if="selectedIndex == 3"/>
      <purchasesData :table_id="'notification-purchases-table'" :arrayData="mainData.purchases" v-if="selectedIndex == 4"/>
      <purchasesData :table_id="'notification-redeem-table'" :arrayData="mainData.redeems" v-if="selectedIndex == 5"/>
    </div>
  </div>
</template>

<script>
import generalData from './general-data';
import nonExisting from './non-existing.vue';
import purchasesData from './purchases-data.vue';

export default {
  components: {generalData, nonExisting, purchasesData},
  
  props: {
    buttons: {
      type: Array,
      required: true
    },
    handleButtonClick: {
      type: Function,
      required: true,
    },

    mainData: {
      type: Object,
      default: {}
    },

    selectedIndex: {
      type: Number,
      default: 0
    }
  },
  
  data() {
    return {
      
    }
  },

  methods: {
    updateNonExistingUsers(updatedArray) {
      this.mainData = {
        ...this.mainData,
        non_existing_users: updatedArray
      };
      // Emit the updated mainData to the parent (if needed)
      this.$emit('update:mainData', this.mainData);
    },
  },


  mounted() {
  }
}

</script>


<style>
.change-background {
  background-color: #5f5f5f;
  color: white;
}
</style>
